import { Link } from 'react-router-dom';
import HeroCarousel from './components/HeroCarousel';
import CategoryGrid from './components/CategoryGrid';
import LatestSection from './components/LatestSection';
import HotSection from './components/HotSection';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

const features = [
  {
    icon: 'ri-hd-line',
    title: '高清资源',
    desc: '整理最新与经典动漫，画质清晰、更新及时，追番更顺畅。',
  },
  {
    icon: 'ri-filter-3-line',
    title: '多维筛选',
    desc: '按类型、地区、年份与热度自由组合筛选，快速锁定目标作品。',
  },
  {
    icon: 'ri-heart-3-line',
    title: '收藏追番',
    desc: '一键收藏心仪动漫，本地记忆收藏状态，下次访问一目了然。',
  },
];

export default function Home() {
  useDocumentMeta(
    '动漫在线观看-高清动漫视频全集与最新动漫推荐',
    '动漫在线观看网站为您提供丰富的动漫视频资源，涵盖最新和经典动漫作品，支持多分类浏览，让动画爱好者轻松在线观看心仪动漫。',
    '动漫在线观看,动漫视频,动漫全集,动漫推荐,动画片在线观看,最新动漫,动画资源',
  );

  return (
    <div className="w-full">
      <HeroCarousel />
      <CategoryGrid />
      <LatestSection />
      <HotSection />

      <section className="w-full px-4 md:px-8 pb-12">
        <div className="rounded-lg bg-primary-900 px-6 md:px-10 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div key={feature.title} className="flex items-start gap-4">
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 shrink-0">
                <i className={`${feature.icon} text-2xl`}></i>
              </span>
              <div>
                <h3 className="font-heading font-semibold text-background-50 mb-1">{feature.title}</h3>
                <p className="text-sm text-primary-100 leading-relaxed">{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 pb-12">
        <div className="rounded-lg bg-secondary-100 border border-secondary-200 px-6 md:px-10 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div>
            <h3 className="font-heading text-lg md:text-xl font-bold text-secondary-950">
              找不到想看的动漫？
            </h3>
            <p className="text-sm text-secondary-900 mt-1">
              试试搜索关键词，或按分类浏览全部演示内容。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <Link
              to="/search"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-medium whitespace-nowrap cursor-pointer transition-colors"
            >
              <i className="ri-search-line"></i>
              去搜索
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md bg-background-50 hover:bg-background-100 text-secondary-900 font-medium whitespace-nowrap cursor-pointer border border-secondary-300 transition-colors"
            >
              <i className="ri-information-line"></i>
              关于本站
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}